import * as React from 'react';
import axios from "axios";
import PropTypes from 'prop-types';
import { useState } from "react";
import { API } from "../utils/net-api";
import { useLocalStorage } from '@uidotdev/usehooks';

export default function CreatePage({ navigate }) {
    const [rows, setRows] = useState()
    const [linkElement, setLinkElement] = useState(null)
    const char = "\u0000"
    const editor = document.getElementById("editor")
    const [token] = useLocalStorage('token')

    const addLocation = () => {
        let address = document.getElementById("location_address").value
        let latitude = document.getElementById("location_latitude").value
        let longitude = document.getElementById("location_longitude").value
        if (address.length === 0) {
            alert(`Loaction address is null`);
            return
        }
        if (latitude.length === 0) {
            alert(`Loaction latitude is null`);
            return
        }

        if (longitude.length === 0) {
            alert(`Loaction longitude is null`);
            return
        }
        addLinkElement(address, 'location', `${latitude}&${longitude}`)
    }

    const addTime = () => {
        let start = document.getElementById("time_start").value
        let end = document.getElementById("time_end").value
        if (start.length === 0) {
            alert(`Time start is null`);
        }
        if (end.length === 0) {
            alert(`Time end is null`);
        }
        addLinkElement(`${start} ~ ${end}`, 'time', `${start} ~ ${end}`)
    }

    const addLink = () => {
        let title = document.getElementById("link_title").value
        let url = document.getElementById("link_url").value
        if (title.length === 0) {
            alert(`Link title is null`);
        }
        if (title.url === 0) {
            alert(`Link url is null`);
        }
        addLinkElement(title, 'link', url)
    }

    const addLinkElement = (text, key, value) => {
        // 存在则修改。
        if (linkElement) {
            updateLink(linkElement, text, key, value)
            setLinkElement(null)
            // sendMessage()
            return
        }

        // 没有便新建。
        let a = createLink(text, key, value)
        insertLink(a)
    }

    // 创建A标签元素。
    const createLink = (text, key, value) => {
        let span = document.createElement("span")
        let a = document.createElement("a")
        a.setAttribute("contenteditable", false)
        a.setAttribute("draggable", false)
        a.setAttribute("href", '#')
        a.setAttribute("id", value)
        a.setAttribute("class", key)
        a.setAttribute("onclick", `clickLink(this)`)
        a.append(span, document.createTextNode(text))
        return a
    }

    // 修改A标签元素。
    const updateLink = (node, text, key, value) => {
        node.setAttribute("id", value)
        node.setAttribute("class", key)
        node.replaceChild(document.createTextNode(text), node.childNodes[1]) // 1 为A标签的位置。
    }

    // 插入到光标位置上。
    const insertLink = (node) => {
        let selection = window.getSelection()
        let element = selection.focusNode
        if (!inEditor(element)) {
            element = editor
        }
        if (element.textCntent === char) {
            element.textContent = ""
        }
        let input = document.createTextNode(char) // 将光标移到插入的元素后。
        if (element.nodeType === 1) {
            element.append(node, input)
        } else if (element.nodeType === 3) {
            let content = element.textContent
            let range = selection.getRangeAt(0)
            let start = document.createTextNode(content.substring(0, range.startOffset))
            let end = document.createTextNode(content.substring(range.endOffset, content.length))
            element.parentElement.replaceChild(start, element)
            start.after(node, input, end)
        }

        setRange(input)
    }

    const inEditor = (element) => {
        if (element == null) {
            return false
        }
        if (element.id === "editor") {
            return true
        }
        if (element.tagName === "BODY") {
            return false
        }
        return inEditor(element.parentElement)
    }

    const markdown = () => {
        let arr = []
        for (let i = 0; i < editor.childNodes.length; i++) {
            let node = editor.childNodes[i]
            let text = node.textContent.replaceAll(char, "")
            if (text.length === 0) {
                continue
            }
            if (node.nodeType === 3) {
                arr.push(text)
                continue
            }
            if (node.nodeType === 1) {
                let url = ""
                let key = node.className
                let value = node.id
                let title = text
                if (key === "capacity") {
                    title = `\ud83e\uddd1 ${title}`
                    url = `\'capacity#${value}`
                }
                if (key === "location") {
                    title = `\ud83d\udccd ${title}`
                    url = `maps://?saddr=${key}&daddr=${value.replace('&', ',')}`
                }
                if (key === "time") {
                    title = `\ud83d\udcc6 ${title}`
                    let start = Date.parse(value.split("&")[0])
                    url = `calshow:${new Date(start).getTime()}`
                }
                if (key === "link") {
                    title = `\ud83d\udd17 ${title}`
                    url = value.split("&")[1]
                }

                let s = `\n[${title}](${encodeURIComponent(url)})`
                arr.push(s)
            }
        }
        let s = arr.join("")
        console.log(s)
        return s
    }

    const setRange = (node) => {
        let selection = window.getSelection()
        editor.focus()
        let range = document.createRange()
        range.selectNodeContents(node)
        range.setStart(node, node.length)
        range.collapse(true)
        selection.removeAllRanges()

        selection.addRange(range)
    }

    const clickLink = (it) => {
        linkElement = it
        // webkit.messageHandlers.link.postMessage([it.className, it.id])
    }

    const save = () => {
        let title = document.getElementById("title").value
        if (title.length === 0) {
            alert("Post title is null");
        }
        let body = markdown()
        if (body.length === 0) {
            alert("Post title is null");
        }

        let images = document.getElementById("title").value
        if (images.length === 0) {
            continueSave(title, body, [])
            return
        }
        saveImages()
    }

    const saveImages = (title, body) => {

    }

    const continueSave = (title, body, images) => {

    }

    const loadData = (offset, limit) => {
        axios.post(API.users,
            { limit: limit, offset: offset },
            { headers: { 'Authorization': `Bear ${token}` } })
            .then((res) => {
                if (res.status !== 200) {
                    alert(`Get users is Error`);
                    return;
                }
                if (!res.data.Succeed) {
                    alert(res.data.Message);
                    return;
                }
                const data = res.data.Data
                setRows(data);
            })
            .catch((error) => {
                alert(`Get users is ${error}`)
            })
    }


    const postData = (offset, limit) => {
        axios.post(API.waves,
            { limit: limit, offset: offset },
            { headers: { 'Authorization': `Bear ${token}` } })
            .then((res) => {
                if (res.status !== 200) {
                    alert(`Get users is Error`);
                    return;
                }
                if (!res.data.Succeed) {
                    alert(res.data.Message);
                    return;
                }
                const data = res.data.Data
            })
            .catch((error) => {
                alert(`Get users is ${error}`)
            })
    }

    if (!rows) {
        loadData(0, 100);
    }

    return (
        <div id="create-page">
            <h1> Create Post</h1>
            <div>
                Title: <br />
                <input id='title' class='full' type='text' />
            </div>
            <div>
                Body:
                <div class='editor'>
                    <div id="editor" contenteditable="true" ></div>
                    <div>
                        <label>Location:</label>
                        Address <input id="location_address" type="text" />,
                        Latitude <input id="location_latitude" type="text" />,
                        Longitude <input id="location_longitude" type="text" />
                        <button onClick={addLocation}>Add Location</button>
                    </div>
                    <div>
                        <label>Time: </label>
                        Start <input id="time_start" type="datetime-local" />,
                        End <input id="time_end" type="datetime-local" />
                        <button onClick={addTime}>Add Location</button>
                    </div>
                    <div>
                        <label>Link: </label>
                        Title <input id="link_title" type="title" />,
                        URL <input id="link_url" type="text" />
                        <button onClick={addLink}>Add Location</button>
                    </div>
                </div>
            </div>
            <div>
                <label>Images:</label>
                <input id='images' type='file' />
            </div>
            <div>
                <label>Capacity: </label>
                <input id="capacity" type='number' min='0' />
            </div>
            <div> <label>Publish range:</label>
                <select id='publish_range'>
                    <option value={0}>Neighborhood</option>
                    <option value={1}>Community</option>
                    <option value={2}>District</option>
                </select>
            </div>
            <div>
                <label>Burn after:</label>
                <input id='burn_range' type='date' min={new Date().toJSON().slice(0, 10)} />
            </div>
            <div> <label>Public post:</label>
                <select id='publish_post'>
                    <option value={0}>No</option>
                    <option value={1}>Yes</option>
                </select>
            </div>
            <div> <label>Allow to spread:</label>
                <select>
                    <option value={0}>Unallow</option>
                    <option value={1}>Allow</option>
                </select>
            </div>
            <div> <label>Puslish by:</label>
                <select>
                    {(() => {
                        let array = []
                        for (let x in rows) {
                            array.push(<option value={x.id} >{x.name}</option>)
                        }
                        return array;
                    })()}
                </select>
            </div>
            <div>
                <button onClick={save}>Save</button>
            </div>
        </div >
    );
}

CreatePage.propTypes = {
    navigate: PropTypes.func.isRequired,
};